import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { getDate } from '../utilities/getDate';

const AboutSpaceMemberModal = ({ member, onClose }) => {
  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()}>
      <ModalExit />
      <ModalName>About {member.user.name}</ModalName>
      <ModalPart>
        <p>Joined this space on {getDate(member.joinedAt)}.</p>
      </ModalPart>
    </Modal>
  );
};

export default AboutSpaceMemberModal;
